// Polyfill for our intersection-observer for some older browsers.
import 'intersection-observer'

// Polyfill for Smooth Scroll behavior polyfill missing for Safari Mac and iOS Safari
import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()
